function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\r\n@keyframes j8o5xh62tszltqfy2mp2rt4x_t { 0% { transform: translate(60.5px,8px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 48.995% { transform: translate(60.5px,15px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { transform: translate(60.5px,8px); } }\r\n@keyframes vic3xd8bmblp8byjn90779yp_t { 0% { transform: translate(89px,58px) scale(1,1) translate(-29.9px,-9px); animation-timing-function: cubic-bezier(.4,0,.6,1); } .656% { transform: translate(89px,58px) scale(1,0) translate(-29.9px,-9px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 1.649% { transform: translate(89px,58px) scale(1,1) translate(-29.9px,-9px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 4.967% { transform: translate(89px,58px) scale(1,1) translate(-29.9px,-9px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 5.961% { transform: translate(89px,58px) scale(1,0) translate(-29.9px,-9px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 6.954% { transform: translate(89px,58px) scale(1,1) translate(-29.9px,-9px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { transform: translate(89px,58px) scale(1,1) translate(-29.9px,-9px); } }\r\n@keyframes bqwiypyfx653o0ly1guec6bm_t { 0% { transform: translate(-62.5px,-10.5px); animation-timing-function: cubic-bezier(0,0,.7,1); } 57.446% { transform: translate(-62.5px,-13.5px); } 100% { transform: translate(-62.5px,-10.5px); } }\r\n@keyframes a0j058mbbddt5l0lzcg9u2f8_t { 0% { transform: translate(263.7px,60.5px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 50% { transform: translate(263.7px,58.5px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { transform: translate(263.7px,60.5px); } }\r\n@keyframes iypryhfe3l5qxf6s7f4yk7gq_t { 0% { transform: translate(36.5px,27.5px) rotate(45deg) scale(.8,.8) translate(-32.5px,-25.5px); animation-timing-function: cubic-bezier(0,0,.6,1); } 48.56% { transform: translate(36.5px,27.5px) rotate(45deg) scale(1,1) translate(-32.5px,-25.5px); animation-timing-function: cubic-bezier(0,0,.6,1); } 100% { transform: translate(36.5px,27.5px) rotate(45deg) scale(.8,.8) translate(-32.5px,-25.5px); } }\r\n@keyframes plu4thr2q42gnyfhoza1v9zy_t { 0% { transform: translate(48px,50.2px) rotate(45deg) scale(1,1) translate(-44.1px,-48.1px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 38.462% { transform: translate(48px,50.2px) rotate(45deg) scale(1.2,1.2) translate(-44.1px,-48.1px); animation-timing-function: cubic-bezier(.4,0,.6,1); } 100% { transform: translate(48px,50.2px) rotate(45deg) scale(1,1) translate(-44.1px,-48.1px); } }\r\n");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Mistake");

var _ref4 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-61,-12)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M162 12c3.3 0 6.1 2.3 6.8 5.4c32.3 8.3 56.2 37.7 56.2 72.6c0 7.7-1.1 15-3.3 22h-143.4c-2.2-7-3.3-14.3-3.3-22c0-35.3 24.4-64.9 57.3-72.9c.8-2.9 3.5-5.1 6.7-5.1h23Z",
  stroke: "#5c8df6",
  strokeWidth: 4,
  fill: "#fff",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158 21c3 0 5.6 1.9 6.6 4.6c28.9 6.7 50.4 32.5 50.4 63.4c0 7.7-1.3 15.1-3.8 22h-122.4c-2.5-6.9-3.8-14.3-3.8-22c0-31.3 22.1-57.4 51.5-63.6c1-2.6 3.6-4.4 6.5-4.4h15Z",
  stroke: "#5c8df6",
  strokeWidth: 4,
  fill: "#92bfff",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M168.2 30.3c1 .4 1.6 1.5 1.2 2.6l-3 9.5c-0.4 1-1.5 1.6-2.6 1.3c-1-0.4-1.6-1.5-1.2-2.6l3-9.5c.4-1 1.5-1.6 2.6-1.3Z",
  fill: "#5c8df6"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#5c8df6",
  width: 4,
  height: 14,
  rx: 2,
  transform: "translate(168,42) rotate(38) translate(-2,-7)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#5c8df6",
  strokeLinejoin: "round",
  strokeWidth: 4,
  transform: "translate(74,37)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M76 0c10.3 0 19.6 3.4 26.4 9h9.8c.5 0 1.1 0 1.6 .1l33.3 5.1c2.8 .5 4.9 2.9 4.9 5.8c0 3.1-1.7 5.9-4.4 7.4l-20.9 11.6c-4.7 2.6-9.9 4-15.1 4.3c-5.5 12.1-19.3 20.7-35.6 20.7c-16.3 0-30.1-8.6-35.6-20.7c-5.2-0.3-10.4-1.7-15.1-4.3l-20.9-11.6c-2.7-1.5-4.4-4.3-4.4-7.4c0-2.9 2.1-5.3 4.9-5.8l33.3-5.1c.5-0.1 1.1-0.1 1.6-0.1h9.8c6.8-5.6 16.1-9 26.4-9Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#bed1fb",
  transform: "translate(0,19)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .2l22.4 2.7c10 1.2 17.6 9.7 17.6 19.9v1.5c-5.1-0.4-10.2-1.8-14.7-4.3l-20.9-11.6c-2.7-1.5-4.4-4.3-4.4-7.4c0-0.3 0-0.5 0-0.8Z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#bed1fb",
  transform: "translate(152,19) scale(-1,1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .2l22.4 2.7c10 1.2 17.6 9.7 17.6 19.9v1.5c-5.1-0.4-10.2-1.8-14.7-4.3l-20.9-11.6c-2.7-1.5-4.4-4.3-4.4-7.4c0-0.3 0-0.5 0-0.8Z"
}))), /*#__PURE__*/React.createElement("rect", {
  x: 146,
  y: 82,
  fill: "#5c8df6",
  width: 8,
  height: 4,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.3 87.9l43.7 6.1v22c0 5.5-4.5 10-10 10h-33.5c-11.3 0-20.5-9.2-20.5-20.5c0-9.8 8-17.8 17.8-17.8c.8 0 1.7 0 2.5 .2Z",
  stroke: "#5c8df6",
  strokeWidth: 4,
  fill: "#bed1fb",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.5 86h-1c-11.3 0-20.5 9.2-20.5 20.5c0 11.3 9.2 20.5 20.5 20.5h1c11.3 0 20.5-9.2 20.5-20.5c0-11.3-9.2-20.5-20.5-20.5Z",
  stroke: "#5c8df6",
  strokeWidth: 4,
  fill: "#bed1fb",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(61,96)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M86 21v47.9c-29.4-1.1-54.1-20.9-62.4-47.9h62.4Zm8 47.8v-47.8h59.9c-8.1 26.2-31.6 45.6-59.9 47.8Z",
  stroke: "#5c8df6",
  strokeWidth: 4,
  fill: "#fff",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.3 25v2l-97.5 8c-3.5 0-6.3 2.8-6.3 6.3c0 1.7 .7 3.3 1.9 4.5l.2 .2c9.4 8.7 21.2 14.7 34.4 17v3.8h-0.4l-0.8-0.1c-25.1-2.2-46.7-18.6-55.8-41.7h124.3Zm-55.8 38.9c6.2-0.3 16.2-1.5 21.9-3.4c-6.3 3-13.1 5.1-20.3 6l-0.8 .1h-0.3l-0.5-2.7Z",
  fillOpacity: 0.4,
  fill: "#5c8df6",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 4,
  stroke: "#5c8df6",
  strokeWidth: 4,
  fill: "#fff",
  strokeLinejoin: "round",
  width: 131,
  height: 19
}), /*#__PURE__*/React.createElement("rect", {
  x: 75,
  y: 9,
  stroke: "#5c8df6",
  strokeWidth: 4,
  fill: "#fff",
  strokeLinejoin: "round",
  width: 29,
  height: 9,
  rx: 4.5
}), /*#__PURE__*/React.createElement("g", {
  fill: "#5c8df6",
  transform: "translate(81,12)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 9,
  cy: 1.5,
  rx: 1.5,
  ry: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.5,
  cy: 1.5,
  rx: 1.5,
  ry: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.5,
  cy: 1.5,
  rx: 1.5,
  ry: 1.5
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#5c8df6",
  strokeLinejoin: "round",
  strokeWidth: 4,
  transform: "translate(0,.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5 2.5h4.5v21h-4.5c-5.8 0-10.5-4.7-10.5-10.5c0-5.8 4.7-10.5 10.5-10.5Z",
  fill: "#bed1fb"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18 0h6v26h-6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 9.5h2v6h-2c-1.7 0-3-1.3-3-3c0-1.7 1.3-3 3-3Z",
  fill: "#92bfff"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#5c8df6",
  strokeLinejoin: "round",
  strokeWidth: 4,
  transform: "translate(179,.5) scale(-1,1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.5 2.5h4.5v21h-4.5c-5.8 0-10.5-4.7-10.5-10.5c0-5.8 4.7-10.5 10.5-10.5Z",
  fill: "#bed1fb"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19 0h6v26h-6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 9.5h2v6h-2c-1.7 0-3-1.3-3-3c0-1.7 1.3-3 3-3Z",
  fill: "#92bfff"
}))), /*#__PURE__*/React.createElement("path", {
  stroke: "#5c8df6",
  strokeWidth: 4,
  fill: "#92bfff",
  strokeLinejoin: "round",
  d: "M147 119h8v43h-8Z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(59.9,0) scale(-1,1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5 18c6.4 0 11.5-2.1 11.5-6.5c0-6.4-6.1-11.5-12.5-11.5c-5.6 0-9.5 4-10.3 9.3c-0.1 .3-0.1 .6-0.1 1c-0.1 .8 .2 1.6 .7 2.2c3.2 3.7 6.8 5.5 10.7 5.5Z",
  fill: "#5c8df6"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.5,
  cy: 7.5,
  fill: "#fff",
  rx: 3.5,
  ry: 3.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.5,
  cy: 12.5,
  fill: "#fff",
  rx: 1.5,
  ry: 1.5
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.1,0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5 18c6.4 0 11.5-2.1 11.5-6.5c0-6.4-6.1-11.5-12.5-11.5c-5.6 0-9.5 4-10.3 9.3c-0.1 .3-0.1 .6-0.1 1c-0.1 .8 .2 1.6 .7 2.2c3.2 3.7 6.8 5.5 10.7 5.5Z",
  fill: "#5c8df6"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  transform: "translate(18,4) scale(-1,1)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 3.5,
  cy: 3.5,
  rx: 3.5,
  ry: 3.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.5,
  cy: 8.5,
  rx: 1.5,
  ry: 1.5
})));

var SvgLittleYoda = function SvgLittleYoda(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "180px",
    viewBox: "0 0 300 180",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(150,84.5) translate(-89.5,-76.5)",
    style: {
      animation: "3.33s linear infinite both j8o5xh62tszltqfy2mp2rt4x_t"
    }
  }, _ref5, /*#__PURE__*/React.createElement("g", {
    transform: "translate(89,58) translate(-29.9,-9)",
    style: {
      animation: "5.03s linear 1.85s infinite both vic3xd8bmblp8byjn90779yp_t"
    }
  }, _ref6, _ref7), /*#__PURE__*/React.createElement("path", {
    d: "M181 81c2.2 0 4 1.8 4 4v2.8l.8-1c1.4-1.7 3.9-1.9 5.6-0.5c1.7 1.5 1.9 4 .5 5.7l-7.7 9.2c-0.8 .9-2 1.4-3.2 1.4c-1.2 0-2.4-0.5-3.2-1.4l-7.7-9.2c-1.4-1.7-1.2-4.2 .5-5.7c1.7-1.4 4.2-1.2 5.6 .5l.8 1v-2.8c0-2.2 1.8-4 4-4Z",
    stroke: "#5c8df6",
    strokeWidth: 4,
    fill: "#fff",
    strokeLinejoin: "round",
    transform: "translate(118.5,81.3) translate(-181,-91.8)",
    style: {
      animation: "3.25s linear infinite both bqwiypyfx653o0ly1guec6bm_t"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5c8df6",
    rx: 9,
    ry: 9,
    fillRule: "evenodd",
    transform: "translate(263.7,60.5)",
    style: {
      animation: "2s linear infinite both a0j058mbbddt5l0lzcg9u2f8_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 31.8c-0.7 .4-1.6 .1-1.9-0.6c-0.2-0.4-0.2-0.9 0-1.3c1.3-2.5 1.3-5.6-0.1-8.1l-0.3-0.4c-0.4-0.6-0.1-1.5 .5-1.9c.5-0.2 1-0.2 1.4 0l.4 .3c2.5 1.4 5.6 1.4 8.1 .1c.7-0.4 1.5-0.1 1.9 .6c.2 .4 .2 .9 0 1.3c-1.3 2.5-1.3 5.6 0 8.1c.4 .7 .1 1.5-0.6 1.9c-0.4 .2-0.9 .2-1.3 0c-2.5-1.3-5.6-1.3-8.1 0Z",
    fill: "#5c8df6",
    fillRule: "evenodd",
    transform: "translate(36.5,27.5) rotate(45) scale(.81,.81) translate(-32.5,-25.5)",
    style: {
      animation: "2.88s linear infinite both iypryhfe3l5qxf6s7f4yk7gq_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8 51.7c-0.4 .2-0.9 .1-1.1-0.3c-0.1-0.3-0.1-0.6 0-0.8c.8-1.5 .8-3.3-0.1-4.7l-0.1-0.3c-0.2-0.4-0.1-0.9 .3-1.1c.2-0.2 .6-0.2 .8 0l.3 .1c1.4 .9 3.2 .9 4.7 .1c.4-0.2 .9-0.1 1.1 .3c.2 .3 .2 .6 0 .8c-0.8 1.5-0.8 3.3 0 4.8c.2 .4 .1 .9-0.3 1.1c-0.3 .2-0.6 .2-0.8 0c-1.5-0.8-3.3-0.8-4.8 0Z",
    fill: "#5c8df6",
    fillRule: "evenodd",
    transform: "translate(48,50.2) rotate(45) translate(-44.1,-48.1)",
    style: {
      animation: "1.3s linear infinite both plu4thr2q42gnyfhoza1v9zy_t"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLittleYoda, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/little-yoda.2c5664a7.svg";
export { ForwardRef as ReactComponent };